import { Breadcrumbs, Grid, Link, Typography } from '@mui/material'
import { PADDING_BASE } from '../../assets/Styles'
import TitlebarAction from '../../components/common/TitlebarActions'
import TopSideBar from '../../components/TopSideBar'
import ElementCreate from '../../components/ElementCreate'
import PageContainer from '../../components/common/PageContainer'
import { useProject } from '../../context/ProjectContext'

export default function ElementCreatePage({ setBlockScreen }: any) {

  const { isProjectUndefined } = useProject()

  return (<>
    <TopSideBar currentSection='elements' disableProjectSelector />

    <PageContainer>

      <Grid paddingBottom={PADDING_BASE}>
        <Breadcrumbs aria-label="breadcrumb">
          <Link underline="hover" color="darkgreen" href="/tickets/listing">
            Home
          </Link>
          <Link underline="hover" color="darkgreen" href="/elements/listing">
            Elementos
          </Link>
          <Typography color="darkgreen" fontWeight="bold">
            Nuevo
          </Typography>
        </Breadcrumbs>
      </Grid>

      <TitlebarAction
        title='Nuevo Elemento'
      />

      {!isProjectUndefined() && (
        <ElementCreate
          setBlockScreen={setBlockScreen}
        />
      )}
    </PageContainer>
  </>)
}